import React from "react";

interface UserHeaderProps {
  fullName: string;
  company?: string;
}

const UserHeader: React.FC<UserHeaderProps> = ({ fullName, company }) => {
  const initials = fullName
    .split(" ")
    .map((n) => n[0])
    .join("")
    .toUpperCase();

  return (
    <div className="flex items-center bg-darkcolor-700 gap-[24px] px-[32px] py-[20px]">
      <div className="w-[90px] h-[90px] rounded-full bg-primary-500 text-white flex items-center justify-center text-[28px] font-bold">
        {initials}
      </div>
      <div className="flex flex-col">
        <div className="text-[28px] font-semibold">{fullName}</div>
        <div className="text-[14px] text-neutral-25" style={{color:'#CDD5DF'}}>
          {company && (
            <>
              @ <span className="text-primary-400">{company}</span>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default UserHeader;
